
    <div ngbDropdown *ngIf="initialized" [placement]="placement">
      <button [id]="'selected_' + id" class="btn btn-dropdown" ngbDropdownToggle>
        <div class="selected_name">{{selectionName}}</div>
      </button>

      <div ngbDropdownMenu>
        <button *ngFor="let option of visibleOptions; let i = index"
                [id]="getIdIdentifier(option, i) + '_' + id"
                (click)="select(option)"
                class="dropdown-item"
                [class.active]="isSelected(option)">
          {{option.name()}}
        </button>
      </div>
    </div>
  